export { MaterialSwitchSystem } from './MaterialSwitchSystem'

export interface MaterialSwitchSystemInterface {
  /**
   * 当前类型
   */
  type: string

  /**
   * 切换类型
   */
  switchType(type: string): void

}
